import moment from "moment";
import general from "@/helpers/general";

export default class ParseUser {
  static parse(user) {
    return {
      _id: user._id,
      user_name: user.username,
      full_name: user.firstName + " " + user.lastName,
      first_Name: user.firstName,
      last_Name: user.lastName,
      email: user.email,
      models: user.models || [],
      role: user.role,
      //role: general.ucFirst(user.role),
      //createdTs: user.createdTimestamp,
      createdTs: user.created,
      //created: moment(user.createdTimestamp).format("MMMM Do YYYY, h:mm:ss a"),
      created: moment(user.created).format("MMMM Do YYYY, h:mm:ss a")
    };
  }

  static parseArray(users) {
    return users.map(user => this.parse(user));
  }
}
